// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ofoQ2","right":"styles_right__237xn"};